import { render, staticRenderFns } from "./pinglun.vue?vue&type=template&id=f158eb36&scoped=true"
import script from "./pinglun.vue?vue&type=script&lang=js"
export * from "./pinglun.vue?vue&type=script&lang=js"
import style0 from "./pinglun.vue?vue&type=style&index=0&id=f158eb36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f158eb36",
  null
  
)

export default component.exports